import { render, staticRenderFns } from "./ControlsHeader.vue?vue&type=template&id=95c52486&scoped=true&"
import script from "./ControlsHeader.vue?vue&type=script&lang=js&"
export * from "./ControlsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ControlsHeader.vue?vue&type=style&index=0&id=95c52486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c52486",
  null
  
)

export default component.exports